var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-flag"},[_c('span',{staticClass:"status-flag__left"}),_c('span',{staticClass:"status-flag__right"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }